<template>
  <label :for="id" class="flex">
    <input
      :id="id"
      ref="input"
      v-bind="$attrs"
      class="sr-only"
      :checked="modelValue"
      :disabled="disabled"
      type="checkbox"
      @input="updateValue"
    />
    <div
      class="relative inline-flex h-5 w-9 rounded-full transition-all duration-300 md:h-6 md:w-11"
      :class="[
        inputClass,
        disabled
          ? 'cursor-not-allowed bg-disabled'
          : ['cursor-pointer', modelValue ? 'bg-primary' : 'bg-neutral-300']
      ]"
    >
      <div
        class="absolute left-0.5 top-0.5 block h-4 w-4 rounded-full bg-white transition-all duration-300 md:h-5 md:w-5"
        :class="[indicatorClass, modelValue && 'translate-x-full']"
      />
    </div>
    <span v-if="isLabelVisible" class="flex cursor-pointer items-center gap-2 pl-2">{{
      label
    }}</span>
  </label>
</template>

<script setup lang="ts">
interface InputProps {
  indicatorClass?: string
  inputClass?: string
  label: string
  isLabelVisible?: boolean
  modelValue: boolean
  disabled?: boolean
}

defineOptions({
  inheritAttrs: false
})

withDefaults(defineProps<InputProps>(), {
  indicatorClass: 'form-toggle-indicator',
  inputClass: 'form-toggle',
  modelValue: false,
  disabled: false,
  isLabelVisible: true
})

const emit = defineEmits(['update:modelValue', 'change'])

const updateValue = (e: Event) => {
  const checked = (e.target as HTMLInputElement).checked
  emit('update:modelValue', checked)
  emit('change', checked)
}

const id = useId()
</script>
